export const BRAND = 'EBOOKSTORE™';
export const PRODUCT_NAME = 'Kit Primeros 90 Días con tu Bebé';
export const CHECKOUT_URL = 'https://kit-primeros-90-dias-con-tu-bebe.impultienda.ar/checkout';
export const OFFER_SECTION_ID = 'oferta';
export const PRODUCT_IMAGE = 'https://cdn.magicpatterns.com/uploads/qay5z7Wi6uKjvbC48SADbc/Kit_primeros_90_dias_con_tu_bebe_(1).png';
export const PRICE = '$19.990 ARS';
export const CONTACT_EMAIL = 'ebookstore028@gmail.com';

export const quickStats = [
  { value: '5', label: 'Volúmenes prácticos e ilustrados' },
  { value: '4', label: 'Bonos con herramientas de organización' },
  { value: '90', label: 'Días de acompañamiento y aprendizaje' },
  { value: '13', label: 'Planificadores semanales' },
  { value: '1', label: 'Sistema completo y organizado' },
];

export const galleryImages = [
  {
    src: 'https://cdn.magicpatterns.com/uploads/9QrbehRa1SVCo3FHHXGpXA/Captura_de_pantalla_2026-10-23_062818.png',
    alt: 'Sabé dónde vas a recibir atención: qué conviene confirmar en la maternidad',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/jJLqrFS1W5nRgMg3TbY9z9/Captura_de_pantalla_2026-10-23_062837.png',
    alt: 'Qué ropa conviene tener preparada para el bebé',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/5W3fQD7QcNuUCGmLEp1mNA/Captura_de_pantalla_2026-10-23_062907.png',
    alt: 'Así debe verse un espacio de descanso seguro',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/b6RfvXFiotKxVme9FyxMJH/Captura_de_pantalla_2026-10-23_063145.png',
    alt: 'Prepará tu bolso de maternidad con lo necesario',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/ppsy5zpfThqewQwsnuZqmh/Captura_de_pantalla_2026-10-23_063214.png',
    alt: 'Cuidados preventivos en la maternidad',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/iRX13CrXtdfQUnGZQwkJUc/Captura_de_pantalla_2026-10-23_063230.png',
    alt: 'La pesquisa neonatal: un estudio importante para la salud de tu bebé',
  },
];

export const withoutSystem = [
  'Buscar respuestas en diferentes páginas.',
  'Encontrar consejos contradictorios.',
  'Preparar listas desde cero.',
  'Tener información y recordatorios dispersos.',
  'Organizar todo sin herramientas claras.',
];

export const withSystem = [
  '5 guías ilustradas y organizadas.',
  'Información clara sobre cuidados, alimentación y desarrollo.',
  'Recursos para el bienestar materno.',
  'Planificadores y checklists listas para usar.',
  'Herramientas de organización familiar.',
];

export const faqs = [
  {
    q: '¿Para quién está pensado este kit?',
    a: 'Para embarazadas primerizas, madres con bebés de hasta tres meses y familias que buscan recursos educativos y prácticos para organizar los cuidados y las tareas cotidianas.',
  },
  {
    q: '¿Puedo comprarlo si mi bebé ya nació?',
    a: 'Sí. Podés consultar directamente los volúmenes y herramientas que sean útiles para la etapa en la que te encontrás.',
  },
  {
    q: '¿Necesito tener conocimientos previos?',
    a: 'No. El contenido está pensado para explicarse mediante lenguaje sencillo, imágenes, ejemplos y procedimientos visuales.',
  },
  {
    q: '¿Qué incluye exactamente?',
    a: 'Cinco volúmenes sobre preparación para el nacimiento, cuidados diarios, alimentación, sueño y desarrollo, y bienestar materno, más cuatro bonos con planificadores, fichas de alerta, checklists y herramientas de organización familiar.',
  },
  {
    q: '¿Incluye información sobre lactancia y alimentación con fórmula?',
    a: 'Sí. El Volumen 3 aborda la lactancia materna, la leche extraída y los cuidados generales relacionados con el uso de fórmula infantil.',
  },
  {
    q: '¿Me ayuda a organizar los controles y las vacunas?',
    a: 'Sí. El Bono 1 incluye herramientas para registrar fechas, consultas, vacunas, estudios y preguntas para profesionales.',
  },
  {
    q: '¿Los bonos se pueden imprimir?',
    a: 'Las planillas y fichas preparadas para impresión pueden utilizarse en papel. Las posibilidades de edición digital dependen del formato de los archivos incluidos.',
  },
  {
    q: '¿Este kit reemplaza las consultas al pediatra o al médico?',
    a: 'No. Es material educativo y no reemplaza consultas, controles, diagnósticos ni tratamientos médicos. Ante síntomas preocupantes, consultá a profesionales de salud.',
  },
  {
    q: '¿Incluye recomendaciones sobre el posparto?',
    a: 'Sí. El Volumen 5 aborda recuperación física, bienestar emocional, descanso, apoyo familiar y aspectos del seguimiento materno.',
  },
  {
    q: '¿Cómo recibo el material?',
    a: 'Después de confirmar el pago, recibís acceso a los archivos digitales mediante el sistema de entrega de la tienda.',
  },
  {
    q: '¿Puedo utilizarlo desde mi celular?',
    a: 'Sí. El material digital está pensado para consultarse desde celulares, tablets y computadoras.',
  },
  {
    q: '¿Los cuatro bonos están incluidos?',
    a: 'Sí. Los cuatro bonos forman parte del kit completo, sin necesidad de comprarlos individualmente.',
  },
  {
    q: '¿Es un pago único?',
    a: 'Sí. Pagás una sola vez $19.990 ARS, sin suscripción mensual.',
  },
];

export const recentBuyers = [
  { name: 'Camila Gómez', city: 'Córdoba' },
  { name: 'Lucía Fernández', city: 'Rosario' },
  { name: 'Agustina Romero', city: 'Mendoza' },
  { name: 'Carolina Sosa', city: 'La Plata' },
  { name: 'Martina Álvarez', city: 'San Miguel de Tucumán' },
  { name: 'Valeria Díaz', city: 'Mar del Plata' },
  { name: 'Julieta Medina', city: 'Salta' },
  { name: 'Sofía Molina', city: 'Neuquén' },
  { name: 'Lorena Torres', city: 'Santa Fe' },
  { name: 'Pablo Ruiz', city: 'Bahía Blanca' },
  { name: 'Gabriela Benítez', city: 'Posadas' },
  { name: 'Micaela Herrera', city: 'Buenos Aires' },
  { name: 'Florencia Castro', city: 'Corrientes' },
  { name: 'Matías Acosta', city: 'San Juan' },
  { name: 'Natalia Aguirre', city: 'Resistencia' },
  { name: 'Rocío Giménez', city: 'Río Cuarto' },
];
